(function($, Drupal) {
  'use strict';
  // Any JS related to layout builder blocks
  Drupal.behaviors.layout_blocks = {
    attach: function(context, settings) {
      // Reusable functions
      function isEven(value) {
        if (value % 2 === 0) {
          return true;
        }
        else {
          return false;
        }
      }

      // Add class to last two cards
      let $card_blocks = $('.field--name-field-cards', context);
      $card_blocks.each(function() {
        let $cards = $(this).find('> .field__item');

        if (isEven($cards.length)) {
          $cards.slice(-2).addClass('last-two');
        }
      });

      // Divide and wrap taxonomy accordions
      let $accordion_items = $('.view-institute-centers-networks-and-labs .view-content > .views-row', context);
      let $accordion_split = Math.round($accordion_items.length / 2);
      for (let i = 0; i < $accordion_items.length; i += $accordion_split) {
        $accordion_items.slice(i, i + $accordion_split).wrapAll("<div class='accordion-column'></div>");
      }
    }
  };
})(jQuery, Drupal);
